<kendo-tabstrip (tabSelect)="setTabClick($event)" [keepTabContent]="true">
  <kendo-tabstrip-tab [title]="'page.CommandEventDetail.Title' | translate" [selected]="true">
    <ng-template kendoTabContent>
      <app-event-export
        [event]="event"
        [payloadTypes]="data?.payloadTypes"
      ></app-event-export>
    </ng-template>
  </kendo-tabstrip-tab>
  <kendo-tabstrip-tab [title]="'$lbl.source' | translate">
    <ng-template kendoTabContent>
      <app-event-export
        [event]="eventSource"
        [payloadTypes]="data?.payloadTypes"
      ></app-event-export>
    </ng-template>
  </kendo-tabstrip-tab>
</kendo-tabstrip>
